const relativize = (x: number, y: number, node: HTMLElement): ICoordinate => {
  const { left, top } = node ? node.getBoundingClientRect() : { left: 0, top: 0 };

  return (typeof x !== 'number' || typeof y !== 'number') ? { x: 0, y: 0 } : {
    x: Math.floor(x - left),
    y: Math.floor(y - top),
  };
};

export default relativize;
